import React, { useMemo } from "react";

const MESSAGES = {
  en: {
    morning: ["Good morning", "Fresh start", "New ideas today"],
    afternoon: ["Good afternoon", "Keep momentum", "Build something useful"],
    evening: ["Good evening", "Slow down", "Wrap things well"],
    night: ["Still here?", "Late focus", "Quiet progress"],
  },
  fr: {
    morning: ["Bonjour", "Nouvelle journée", "Idées fraîches"],
    afternoon: ["Bon après-midi", "Garde le rythme", "Avance bien"],
    evening: ["Bonsoir", "Ralentis", "Bonne clôture"],
    night: ["Encore debout ?", "Concentration tardive", "Progrès discret"],
  },
};

const bucket = (h) => {
  if (h < 12) return "morning";
  if (h < 18) return "afternoon";
  if (h < 22) return "evening";
  return "night";
};

export default function Greeting({ name, locale = "en" }) {
  const key = bucket(new Date().getHours());

  const message = useMemo(() => {
    const list = MESSAGES[locale][key];
    const randomIndex = Math.floor(Math.random() * list.length);
    return list[randomIndex];
  }, [locale, key]);

  return (
    <div style={{ fontSize: 32, fontWeight: 500 }}>
      {message}{name ? `, ${name}` : ""}
    </div>
  );
}
